import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Title from "antd/es/typography/Title";
import {
  Space,
  Row,
  Badge, Calendar, Button
} from "antd";
import moment from "moment";
import { UseGetRequest, UsePostRequest } from "../../utils/api/ApiRequests";
import '../../cssFiles/CustomStyles/EventCalendar.css';

export default function EventsCalendar() {
  const navigate = useNavigate();
  const date = new Date();
  const filterConfig = {
    status: "approved",
  };

  const [holidays, setHolidays] = useState([]);
  const [leaves, setLeaves] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [memos, setMemos] = useState([]);
  const [birthdays, setBirthdays] = useState([]);
  const [anniversaries, setAnniversaries] = useState([]);
  const [formattedTime, setFormattedTime] = useState()

  const getListData = (value, period) => {
    const calendarDate = period==="date"?value.format('YYYY-MM-DD'):value.format('YYYY-MM');
    const calendarDateOnly = period==="date"?value.format('MM-DD'):value.format('MM');

    const calendarDateFormat = period==="date" ? 'YYYY-MM-DD' : 'YYYY-MM';
    const calendarDateOnlyFormat = period==="date" ? 'MM-DD' : 'MM';

    const holidayEvents = holidays.filter(data => moment(data.date).format(calendarDateFormat) === calendarDate);
    const tempLeaves = leaves.filter(data => moment(data.date).format(calendarDateFormat) === calendarDate);
    const tempAnnouncements = announcements.filter(data => moment(data.announcement_date).format(calendarDateFormat) === calendarDate);
    const tempMemos = memos.filter(data => moment(data.memo_date).format(calendarDateFormat) === calendarDate);
    const tempBirthdays = birthdays.filter(data => moment(data.birthdate).format(calendarDateOnlyFormat) === calendarDateOnly);
    const tempAnniv = anniversaries.filter(data => moment(data.date_hired).format(calendarDateOnlyFormat) === calendarDateOnly);

    let listData = []
    holidayEvents.forEach((event) => {
      let info = {}
      info.type = 'holiday';
      info.content = `🎄 ${event.name}`;
      info.className = "holiday-badge";
      listData.push(info);
    })

    tempAnnouncements.forEach((event) => {
      let info = {}
      info.type = 'announcement';
      info.content = `📢 ${event.subject}`;
      info.className = "announcement-badge";
      listData.push(info);
    })

    tempMemos.forEach((event) => {
      let info = {}
      info.type = 'memo';
      info.content = `📝 ${event.subject}`;
      info.className = "memo-badge";
      listData.push(info);
    })

    tempBirthdays.forEach((event) => {
      let info = {}
      info.type = 'birthday';
      info.content = `🎂 ${event.name}`;
      info.className = "birthday-badge";
      listData.push(info);
    })

    tempAnniv.forEach((event) => {
      let info = {}
      info.type = 'anniversary';
      info.content = `💼 ${event.name}`;
      info.className = "anniversary-badge";
      listData.push(info);
    })

    tempLeaves.forEach((event) => {
      let info = {}
      info.type = 'leave';
      info.content = `🚘 ${event.last_name} - ${event.leave_type}`;
      info.className = "leave-badge";
      listData.push(info);
    })

    return listData;
  };

    const monthCellRender = (value) => {
      const listData = getListData(value, "month");
      return (
        <Row className="events">
          {listData?.map((item) => (
              <Badge status={item.type} text={item.content} className={item.className}/>
          ))}
        </Row>
      )
    };

    const dateCellRender = (value) => {
      const listData = getListData(value, "date");
      return (
        <Row className="events">
          {listData?.map((item) => (
              <Badge status={item.type} text={item.content} className={item.className}/>
          ))}
        </Row>
      );
    };

  const cellRender = (current, info) => {
    if (info.type === 'date') return dateCellRender(current);
    if (info.type === 'month') return monthCellRender(current);
    return info.originNode;
  };


  React.useEffect(() => {
    const timer = setInterval(() => {
      const newDate = new Date();
       const tempTime = newDate.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  })
  setFormattedTime(tempTime)
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  React.useEffect(() => {
    async function fetchAllData() {
      setHolidays([])
      setLeaves([])
      setAnnouncements([])
      setMemos([]);
      setBirthdays([]);
      setAnniversaries([]);

      const tempHolidays = await UsePostRequest("holidays/get", filterConfig);
      if (tempHolidays.data) {
          setHolidays(tempHolidays.data);
      }

      const tempLeaves = await UsePostRequest("employee_leaves/get", filterConfig);
      if (tempLeaves.data) {
        const tempArray = []
        tempLeaves.data.forEach((row) => {
          const startDate = new Date(row.date_from);
          const endDate = new Date(row.date_to);

          for (let date=startDate; date<=endDate; date=date.getDate()+1) {
            let info = {}
            info.last_name = row.employee_name.split(',')[0];
            info.date = moment(date).format('YYYY-MM-DD');
            info.leave_type = row.leave_type;
            tempArray.push(info);
          }
        })
        setLeaves(tempArray);
      }

      const tempAnnouncements = await UseGetRequest("announcements/get", filterConfig);
      if (tempAnnouncements.data) {
        setAnnouncements(tempAnnouncements.data.data.announcements);
      }

      const tempMemos = await UseGetRequest("memos/get", filterConfig);
      if (tempMemos.data) {
        setMemos(tempMemos.data.data.memos);
      }

      const employeeData = await UsePostRequest("employees/get_all", {});
      if (employeeData.data) {
        const temp = employeeData.data.map((row) => {
          let info = {}
          info.name = `${row.first_name} ${row.middle_name} ${row.last_name}`;
          info.birthdate = row.birthdate;
          info.date_hired = row.date_hired;
          return info;
        })
        setBirthdays(temp);
        setAnniversaries(temp);
      }
    }

    fetchAllData();
  }, []);


  return (
    <Navbar activeNav="dashboard">
      <Space className="d-flex justify-content-between p-3" wrap>
        <Title level={4}>
          {moment(date).format("MMMM DD, YYYY")}, {formattedTime}
        </Title>
        <Button onClick={() => navigate(-1)}>BACK TO DASHBOARD</Button>
      </Space>

      <Row>
        <Calendar cellRender={cellRender} />
      </Row>
    </Navbar>
  );
}
